import * as accounting from 'accounting';


function amountWithTax(amount, taxRate) {
  return (accounting.unformat(amount) * (taxRate + 1)).toString();
}

function updatePrices(bundledProduct, price) {
  const currentListing = bundledProduct.listing;

  const listing = Object.assign(currentListing, {
    price: Object.assign(currentListing, {
      amount: price,
      symbol: currentListing.original_price.symbol,
    }),
    buyer_price: Object.assign(currentListing.buyer_price, {
      amount: amountWithTax(price, currentListing.buyer_price.tax_included_rate),
    }),
  });

  return Object.assign(bundledProduct, { listing });
}

function updateFreeShipping(bundledProduct, freeShipping) {
  return Object.assign(bundledProduct, { free_shipping: freeShipping });
}


export {
  updatePrices,
  updateFreeShipping,
};



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/bundled_product_updater.js